import { render, staticRenderFns } from "./DashboardContractView.vue?vue&type=template&id=2dd87496&scoped=true&"
import script from "./DashboardContractView.vue?vue&type=script&lang=js&"
export * from "./DashboardContractView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd87496",
  null
  
)

export default component.exports